import { type QueryKey, skipToken, useQuery } from '@tanstack/react-query';
import { isObject } from 'lodash';

import { SavedFilters } from '@air/api';

export const PRIVATE_SAVED_SEARCH_KEY = 'PRIVATE_SAVED_SEARCH';

export type PrivateSavedSearchKey = [typeof PRIVATE_SAVED_SEARCH_KEY, UsePrivateSavedSearchParams];

export const getPrivateSavedSearchKey = (params: UsePrivateSavedSearchParams): PrivateSavedSearchKey => {
  return [PRIVATE_SAVED_SEARCH_KEY, params];
};

export const isPrivateSavedSearchKey = (key: QueryKey): key is PrivateSavedSearchKey => {
  return Array.isArray(key) && key[0] === PRIVATE_SAVED_SEARCH_KEY && isObject(key[1]);
};

export type UsePrivateSavedSearchParams = {
  id: string | undefined;
};

export type UsePrivateSavedSearchOptions = { enabled?: boolean };

export const usePrivateSavedSearch = (params: UsePrivateSavedSearchParams, options?: UsePrivateSavedSearchOptions) => {
  const { id } = params;

  return useQuery({
    queryKey: getPrivateSavedSearchKey(params),
    /**
     * @TODO - Sync w/ BE on getting this updated to support passing in an object.
     */
    queryFn: !id ? skipToken : () => SavedFilters.getSavedFilter(id),
    enabled: !!id && options?.enabled,
  });
};
